import React, { useState, useEffect, forwardRef } from "react";
import Article from "./Article";
import SmallArticle from "./SmallArticle";
import CopyText from "./CopyText";
import Quote from "./Quote";
import { apDateTimeLocale } from "./utils";
import * as d3 from "d3";

import data from "../../../template/copy.json";
const formatDay = apDateTimeLocale.format("%B %d"),
  formatMonth = apDateTimeLocale.format("%B"),
  formatYear = apDateTimeLocale.format("%Y");

function multiFormat(date) {
  return (d3.timeMonth(date) < date
    ? formatDay
    : d3.timeYear(date) < date
    ? formatMonth
    : formatYear)(date);
}
const Timeline = forwardRef(({ width, x }, ref) => {
  const ticks = x.ticks(d3.utcWeek);
  // const fmt = apDateTimeLocale.format("%B");
  return (
    <div
      style={{ minWidth: width, position: "relative" }}
      className="timeline"
      ref={ref}
    >
      {ticks.map((tick) => {
        return (
          <div
            style={{ position: "absolute", left: x(tick) }}
            className="date-tick"
            key={tick}
          >
            {multiFormat(tick)}
          </div>
        );
      })}
      {data.body.smallStories
        .filter((d) => !!d)
        .map((article, i) => {
          return <SmallArticle article={article} key={i} x={x} />;
        })}
      {data.body.copy
        .filter((d) => !!d)
        .map((article, i) => {
          return <CopyText article={article} key={i} x={x} />;
        })}
      {data.body.bigStories
        .filter((d) => !!d)
        .map((article, i) => {
          return <Article article={article} key={i} x={x} />;
        })}
      {data.body.quotes
        .filter((d) => !!d)
        .map((quote, i) => {
          return <Quote quote={quote} key={i} x={x} />;
        })}
    </div>
  );
});

export default Timeline;
